import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type ColorOptionsListClasses = 'container';

const colorOptionsListStyles = makeStyles<ISpcTheme, ColorOptionsListClasses>(
  () => ({
    container: {
      position: 'relative',
      top: 0,
    },
  }),
  { name: 'Common_ColorOptionsList' },
);

export default colorOptionsListStyles;
